// Generated by tools/art/publish_art.mjs; re-run it rather than editing this.

/**
 * Each rendered file (the hero loop, the crest) by the address pages and layouts
 * use for it, to the file holding the current render. The file name carries a
 * hash of its content, so a re-render is a new URL and no cache can serve the
 * old one. Look addresses up with artUrl() (shared/artUrl.ts).
 */
export const RENDERED_ART: Readonly<Record<string, string>> = {
  '/hero/league-party.webm': '/hero/league-party.7a41725e.webm',
  '/hero/league-party.mp4': '/hero/league-party.33d65692.mp4',
  '/hero/league-party.webp': '/hero/league-party.b6b8f561.webp',
  '/crest/league-crest.webp': '/crest/league-crest.c8a601f1.webp',
  '/crest/league-crest-still.webp': '/crest/league-crest-still.5e2c0b71.webp',
  '/crest/league-crest-logo.webp': '/crest/league-crest-logo.fe2987d3.webp',
};
